// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notfound[data-v-1d722879] {\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n}\n.notfound .content[data-v-1d722879] {\n  padding: 223px 0;\n  text-align: center;\n}\n.notfound .content img[data-v-1d722879] {\n  width: 509px;\n  height: 275px;\n  vertical-align: middle;\n}\n.notfound .content p[data-v-1d722879] {\n  height: 25px;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 25px;\n  color: #333;\n}", ""]);
// Exports
module.exports = exports;
